import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { HttpClient } from '@angular/common/http';
import { map, mergeMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import {
  loadSyriaBoundary,
  loadSyriaBoundaryFailure,
  loadSyriaBoundarySuccess,
} from '../actions/syria-boundary.actions';

@Injectable()
export class SyriaBoundaryEffects {
  loadBoundary$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadSyriaBoundary),
      mergeMap(() =>
        this.http.get('data/geoBoundaries-SYR-ADM0.geojson').pipe(
          map((data: any) =>
            loadSyriaBoundarySuccess({
              boundary: data.type === 'FeatureCollection' ? data.features[0] : data,
            })
          ),
          catchError((error) => of(loadSyriaBoundaryFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private http: HttpClient
  ) {}
}
